import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export type QuestCalendarSkeletonProps = {
  isToday: boolean;
};

export const QuestCalendarSkeleton: FC<QuestCalendarSkeletonProps> = ({ isToday }) => {
  return (
    <Stack borderBottom={isToday ? undefined : '1px solid var(--tg-theme-section-bg-color)'}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        paddingLeft="14px"
        paddingRight="14px"
        paddingTop="12px"
        paddingBottom="12px"
      >
        <Stack gap="4px">
          <ThemedSkeleton
            variant="text"
            width={90}
            height={18}
            sx={{
              fontSize: '0.85rem'
            }}
          />
          <ThemedSkeleton
            variant="text"
            width={140}
            height={16}
            sx={{
              fontSize: '0.75rem'
            }}
          />
        </Stack>
        <ThemedSkeleton
          variant="circular"
          width={40}
          height={40}
        />
      </Stack>
    </Stack>
  );
};

